import { C4ListResponse } from '@domain/interface/c4-list-response';
import { createAction, props } from '@ngrx/store';
import { Owner } from 'cargo-chief-commons';
import { EmailRoutingData } from './state';

export const BOOKING_ASSiSTANT_AUTOMATION = {
	ENABLED_INTEGRATION: {
		GET: createAction('[Enabled Integration] Get enabled integration'),
		SUCCESS: createAction(
			'[Enabled Integration] Get enabled integration success',
			props<C4ListResponse<any>>()
		),
		FAILURE: createAction(
			'[Enabled Integration] Get enabled integration failure',
			props<{ payload: { message: string } }>()
		),
	},

	ENABLED_INTEGRATION_DATA_FIELDS: {
		GET: createAction('[Enabled Integration Data Fields] Get enabled integration data Fields'),
		SUCCESS: createAction(
			'[Enabled Integration Data Fields] Get enabled integration data fields success',
			props<C4ListResponse<any>>()
		),
		FAILURE: createAction(
			'[Enabled Integration Data Fields] Get enabled integration Data Fields failure',
			props<{ payload: { message: string } }>()
		),
	},

	BOOKING_ASSISTANT_DATA_FIELDS: {
		GET: createAction('[Booking Assistant Data Fields] Get booking assistant data Fields'),
		SUCCESS: createAction(
			'[Enabled Integration Data Fields] Get booking assistant data fields success',
			props<C4ListResponse<any>>()
		),
		FAILURE: createAction(
			'[Booking Assistant Data Fields] Get booking assistant data fields failure',
			props<{ payload: { message: string } }>()
		),
	},

	BOOKING_ASSISTANT_PAGE_DATA: {
		UPDATE: createAction(
			'[Booking Assistant Page Data] Update data of booking assistant',
			props<any>()
		),
		SUCCESS: createAction(
			'[Booking Assistant Page Data] Update data of booking assistant success',
			props<any>()
		),
		FAILURE: createAction(
			'[Booking Assistant Page Data] Update data of booking assistant failure',
			props<{ payload: { message: string } }>()
		),
	},

	BOOK_NOW_DATA: {
		SET: createAction('[Book Now Data] Set Book now data', props<{ bookNowData: Array<Object> }>()),
		UPDATED: createAction(
			'[Book Now Data] Book now data updated',
			props<{ bookNowData: Array<Object> }>()
		),
	},

	EMAIL_ROUTING_DATA: {
		SET: createAction(
			'[Email Routing Data] Set email routing data',
			props<{ emailRoutingData: EmailRoutingData }>()
		),
		UPDATED: createAction(
			'[Email Routing Data] Update email routing data',
			props<{ emailRoutingData: EmailRoutingData }>()
		),
	},

	DISPATCH_USER: {
		SET: createAction(
			'[Dispatch User] Set current dispatch user',
			props<{ dispatchUser: Owner }>()
		),
		UPDATE: createAction(
			'[Dispatch User] Selected a new dispatch user',
			props<{ dispatchUser: Owner }>()
		),
	},

	ACTIVE_USERS_LIST: {
		GET: createAction(
			'[Active Users List] Get active users list',
			props<{ activeUsersList: Owner[] }>()
		),
		SET: createAction(
			'[Active Users List] Set active users list',
			props<{ activeUsersList: Owner[] }>()
		),
	},
};
